/**
 * Product API helpers — same origin as ProductSession / invokeApi (API host in prod).
 */
import { getAuthHeaders, ensureFreshIdToken } from "@xinosolutions/xs-auth-react";
import { getWebsiteProductApiBase } from "../config/websiteProductApi";

export function apiUrl(path) {
  const base = getWebsiteProductApiBase().replace(/\/$/, "");
  let p = path.startsWith("/") ? path : `/${path}`;
  if (p.startsWith("/api/")) {
    p = p.slice(4);
  } else if (p === "/api") {
    p = "";
  }
  return `${base}${p}`;
}

const CSRF_HEADER = "X-CSRF-Token";

export async function fetchJson(path, options = {}) {
  const url = apiUrl(path);
  await ensureFreshIdToken();
  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
    ...(options.headers || {}),
  };
  let res = await fetch(url, {
    ...options,
    headers,
    credentials: "include",
  });
  if (res.status === 401 && !options.__authRetry) {
    const token = await ensureFreshIdToken({ force: true });
    if (token) {
      res = await fetch(url, {
        ...options,
        headers: { ...headers, Authorization: `Bearer ${token}` },
        credentials: "include",
      });
    }
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || res.statusText || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function fetchCsrfToken() {
  const data = await fetchJson("/api/general_routes/csrf_token", {
    method: "GET",
  });
  return data.csrf_token || data.csrfToken;
}

export async function postJsonWithCsrf(path, body) {
  const csrf = await fetchCsrfToken();
  return fetchJson(path, {
    method: "POST",
    body: JSON.stringify(body || {}),
    headers: { [CSRF_HEADER]: csrf },
  });
}

/** Clears product session cookies (best-effort; XS Auth logout is primary). */
export async function postLogoutAssociate() {
  try {
    return await postJsonWithCsrf("/api/member_logout", {});
  } catch {
    return null;
  }
}
